import { render, staticRenderFns } from "./StoryCategoriesList.vue?vue&type=template&id=3dabd06a"
import script from "./StoryCategoriesList.vue?vue&type=script&lang=js"
export * from "./StoryCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports